import styled from 'styled-components';
import { spacing } from 'ui/theme';

export const ErrorPageContainer = styled.div`
  min-height: 50vh;
  width: 100%;
  margin-top: ${spacing.double};
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
`;
